export enum CashMovementType {
  OPENING = "OPENING",
  SALE = "SALE",
  INCOME = "INCOME",
  WITHDRAWAL = "WITHDRAWAL",
  REFUND = "REFUND",
  ADJUSTMENT_IN = "ADJUSTMENT_IN",
  ADJUSTMENT_OUT = "ADJUSTMENT_OUT",
  CXP_PAYMENT = "CXP_PAYMENT",
  CXC_PAYMENT = "CXC_PAYMENT"
}

export interface CashMovementSummary {
  type: CashMovementType;
  amount: number;
}

export interface CashCountSummary {
  countedAt: string;
  expectedAmount: number;
  countedAmount: number;
  difference: number;
}

export interface PaymentSummary {
  code: string;
  description: string;
  amount: number;
}

export interface CashRegisterXReport {
  sessionId: number;
  sessionNumber: string;
  user: string;
  openingTime: string;

  totalSales: number;
  expectedCash: number;

  payments: PaymentSummary[];

  // 🔥 NUEVOS
  cashCount?: CashCountSummary;
  movements?: CashMovementSummary[];
}